import { enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { environment } from './environments/environment'
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CommonComponentsModule } from './app/common-components/common-components.module';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { allIcons } from 'angular-feather/icons';
import { FeatherModule } from 'angular-feather';
import { QuillModule } from 'ngx-quill';
import { ShopifyService } from './app/services';
import { AuthInterceptor, InterceptorAppPermission } from './app/interceptors';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';

if (environment.production) {
	enableProdMode()
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(QuillModule.forRoot({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                    // ['blockquote', 'code-block'],
                    [{ header: 1 }, { header: 2 }, { header: 3 }, { header: 4 }, { header: 5 }, { header: 6 }], // custom button values
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                    // [{ 'direction': 'rtl' }],                         // text direction
                    // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    // [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ color: [] }], // dropdown with defaults from theme
                    // [{ 'font': [] }],
                    // [{ 'align': [] }],
                    ['clean'], // remove formatting button
                    ['link'], // link and image, video
                ],
            },
        }), FeatherModule.pick(allIcons), InfiniteScrollModule, BrowserModule, AppRoutingModule, FormsModule, CommonComponentsModule),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorAppPermission, multi: true },
        { provide: LOCALE_ID, useValue: 'en-AU' },
        ShopifyService,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ]
})
	.catch((err) => console.error(err))
